// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"1817e80d","873":"1eda6031"}[chunkId] + ".chunk.js";
};